import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'
import {
  Rule, RuleActive, RuleApi, RuleMutation // eslint-disable-line no-unused-vars
} from '@clients/myTrips'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedRuleApi extends RuleApi {
  getRules (options?: any): AxiosPromise<Array<Rule>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getRules(undefined, optionsParam)
  }

  getRule (id: string, options?: any): AxiosPromise<Rule> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getRule(id, undefined, optionsParam)
  }

  createRule (ruleRequestBody: RuleMutation, options?: any): AxiosPromise<Rule> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.createRule(ruleRequestBody, undefined, optionsParam)
  }

  updateRule (id: string, ruleRequestBody: RuleMutation, options?: any): AxiosPromise<Rule> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateRule(id, ruleRequestBody, undefined, optionsParam)
  }

  updateRuleActive (id: string, ruleRequestActiveBody: RuleActive, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateRuleActive(id, ruleRequestActiveBody, undefined, optionsParam)
  }

  deleteRule (id: string, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.deleteRule(id, undefined, optionsParam)
  }
}
